export class Entity {
  private components: Map<string, any> = new Map();

  constructor(public id: number) {}

  getId(): string {
    return this.id.toString();
  }

  addComponent(name: string, component: any): void {
    this.components.set(name, component);
  }

  getComponent(name: string): any {
    return this.components.get(name);
  }

  getAllComponents(): Record<string, any> {
    return Object.fromEntries(this.components);
  }

  removeComponent(name: string): void {
    this.components.delete(name);
  }
}